// src/queryCache.ts
import { QueryCache as QC } from "@tanstack/query-core";
import { cloneDeepUnref } from "./utils.js";
var QueryCache = class extends QC {
  find(filters) {
    return super.find(cloneDeepUnref(filters));
  }
  findAll(filters = {}) {
    return super.findAll(cloneDeepUnref(filters));
  }
};
export {
  QueryCache
};
//# sourceMappingURL=queryCache.js.map